













































import Vue from 'vue'

interface ClientData {
  phone: string
  email: string
}

export default Vue.extend({
  props: {
    caseId: {
      type: String,
      required: true,
    },
    patient: {
      type: Object,
      required: true,
    },
  },
  computed: {
    contactInformation(): ClientData {
      return {
        phone: this.patient.phone,
        email: this.patient.email,
      }
    },
  },
})
